export default __webpack_public_path__ + "static/media/ball.01b83926.png";